import Alert from '@risk-smart/themed-cloudscape-components/alert';
import Button from '@risksmart-app/components/src/button';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './style.module.scss';

interface Props {
  /** How many filters are active. `0` renders nothing. */
  count: number;
  onClear: () => void;
}

/**
 * "N filters applied" notice with an inline clear link, shown above the overall
 * dashboard's filter row. Shared by the toolbar banner and the legacy header so
 * the two flag paths cannot drift.
 */
export const DashboardFiltersAlert: FC<Props> = ({ count, onClear }) => {
  const { t } = useTranslation('common', { keyPrefix: 'dashboard' });

  if (count === 0) {
    return null;
  }

  return (
    <Alert
      type={'info'}
      className={styles.clearFilterAlert}
      header={
        <div className={'flex gap-3 items-center'}>
          {t('filters_alert', { count })}
          {'.'}
          <Button onClick={onClear} variant={'inline-link'}>
            {t('actions.clear')}
          </Button>
        </div>
      }
    />
  );
};
